export default __webpack_public_path__ + "static/media/window-cleaner.5a47bbd0.svg";